import { Box, styled, keyframes } from '@mui/material';

// 定義向外推出的光暈動畫
const glowPulse = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
`;

export const StyledIssueButton = styled(Box)({
  width: '52px',
  height: '52px',
  borderRadius: '50%',
  padding: 0,
  cursor: 'pointer',
  position: 'fixed',
  bottom: 40,
  right: 31,
  transform: 'translate(-50%, -50%)',
  zIndex: 1,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: 'rgba(227, 206, 0, 0.6)',
    // border: '2px solid rgba(227, 206, 0, 0.6)',
    animation: `2s ${glowPulse} ease-out infinite`,
    zIndex: -1,
  },
  // '&:hover': {
  //   transform: 'translate(-50%, -50%) scale(1.1)',
  // },
  transition: 'transform 0.3s ease-in-out',
});
